<template>
  <div class="static-page">
    <HeadNav selectedLanguage="en" page="about" />
    <Breadcrumbs :items="[{ name: 'About Us' }]" />

    <main class="static-content">
      <h1>About Us</h1>

      <p>Welcome to our GB WhatsApp resource website.</p>

      <p>Our goal is to help Android users learn about GB WhatsApp by providing clear information, version updates, installation guides, feature explanations, and APK download resources in one place.</p>

      <p>We are an independent website and are <strong>not affiliated with, endorsed by, or connected to WhatsApp LLC or the developers of GB WhatsApp</strong>. All trademarks, product names, and logos belong to their respective owners.</p>

      <p>Our team regularly reviews new GB WhatsApp releases and updates important information such as version numbers, Android compatibility, file size, new features, and installation instructions. We also publish helpful guides covering updates, backups, troubleshooting, and common questions.</p>

      <p>We strive to keep the information on this website accurate and up to date. However, because GB WhatsApp is a third-party application, features and availability may change without prior notice.</p>

      <p>If you have questions, feedback, or copyright concerns, please contact us via support@gbappsdl.org.</p>
    </main>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';

export default {
  name: 'About',
  components: {
    HeadNav,
    Breadcrumbs
  }
};
</script>

<style lang="scss" scoped>
.static-content {
  width: 80%;
  max-width: 980px;
  margin: 28px auto 96px;
  color: #121212;
  line-height: 1.7;
}

h1 {
  margin: 0 0 24px;
}

p {
  margin: 0 0 16px;
}

@media (max-width: 768px) {
  .static-content {
    width: 88%;
    margin-bottom: 112px;
  }
}
</style>
